import { Component } from '@angular/core';

import { MDTagComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-page-not-found',
	standalone: true,
	imports: [MDTagComponent],
	templateUrl: './page-not-found.component.html',
	styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent {}
